/**
 * Il riquadro dei cookie di PrivacyBull.
 *
 * Su un negozio Shopify parla con il consenso di Shopify (Shopify.customerPrivacy,
 * https://shopify.dev/docs/api/customer-privacy): legge lo stato da lì e scrive la scelta con
 * setTrackingConsent. I pixel montati nel negozio (Meta, TikTok, statistiche di Shopify) obbediscono
 * a quello: finché la scelta non c'è, o è «no», non partono.
 * Su un sito che non è Shopify ricorda la scelta in un suo cookie e accende gli script lasciati
 * spenti con type="text/plain" data-pb-category="statistiche|pubblicita|preferenze".
 *
 * Regole che rispetta (Garante, linee guida 10/6/2021): niente è acceso in partenza; «rifiuta» ha lo
 * stesso aspetto di «accetta»; la X chiude e lascia tutto spento; scorrere la pagina non vale come sì;
 * la scelta si può riaprire in ogni momento (PrivacyBull.apri(), o un collegamento con
 * data-privacybull-apri oppure href="#scelte-cookie").
 *
 * Si configura, prima di caricarlo, con window.PRIVACYBULL = { colori, testi, informativa }.
 */
(function () {
  'use strict';
  if (window.PrivacyBull || window.top !== window) return;

  var dato = window.PRIVACYBULL || {};
  var C = Object.assign({ sfondo: '#ffffff', testo: '#1c1c1c', tenue: '#5a5a5a', tasto: '#1c1c1c', testoTasto: '#ffffff', filo: 'rgba(0,0,0,.18)', carattere: 'inherit' }, dato.colori);
  var T = Object.assign({
    titolo: 'Cookie: scegli tu',
    testo: 'Usiamo cookie tecnici, che servono a far funzionare il sito. Solo se dici di sì usiamo anche cookie per le statistiche e per la pubblicità.',
    informativa: 'Leggi l’informativa',
    accetta: 'Accetta', rifiuta: 'Rifiuta', scegli: 'Scegli', salva: 'Salva le scelte', chiudi: 'Chiudi e rifiuta',
    statistiche: 'Statistiche', statisticheCosa: 'Per capire quali pagine vengono viste, senza sapere chi sei.',
    pubblicita: 'Pubblicità', pubblicitaCosa: 'Per mostrarti i nostri annunci sugli altri siti e sui social.',
    preferenze: 'Preferenze', preferenzeCosa: 'Per ricordare le tue scelte sul sito, come la lingua.',
  }, dato.testi);
  var INFORMATIVA = dato.informativa || '/pages/privacy-e-cookie-policy';
  var COOKIE = 'pb_consent', GIORNI = 180;
  var VOCI = ['statistiche', 'pubblicita', 'preferenze'];

  // ---------- dove sta scritta la scelta ----------

  function shopify(pronto) {
    if (!(window.Shopify && typeof window.Shopify.loadFeatures === 'function')) return pronto(null);
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (errore) {
      pronto(errore || !window.Shopify.customerPrivacy ? null : window.Shopify.customerPrivacy);
    });
  }

  function leggiCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]+)'));
    try { return m ? JSON.parse(decodeURIComponent(m[1])) : null; } catch (e) { return null; }
  }

  // La scelta di adesso: null se il visitatore non ha ancora scelto.
  function leggi(cp) {
    if (cp) {
      var s = cp.currentVisitorConsent();
      if (!s.analytics && !s.marketing && !s.preferences) return null;
      return { statistiche: s.analytics === 'yes', pubblicita: s.marketing === 'yes', preferenze: s.preferences === 'yes' };
    }
    return leggiCookie();
  }

  function scrivi(cp, scelta, fatto) {
    if (cp) return cp.setTrackingConsent({ analytics: scelta.statistiche, marketing: scelta.pubblicita, preferences: scelta.preferenze }, fatto || function () {});
    var v = encodeURIComponent(JSON.stringify(Object.assign({ quando: new Date().toISOString() }, scelta)));
    document.cookie = COOKIE + '=' + v + ';max-age=' + GIORNI * 86400 + ';path=/;SameSite=Lax';
    accendi(scelta);
    if (fatto) fatto();
  }

  // Fuori da Shopify: accende gli script e i riquadri lasciati spenti nella pagina.
  function accendi(scelta) {
    document.querySelectorAll('script[type="text/plain"][data-pb-category]').forEach(function (el) {
      if (!scelta[el.getAttribute('data-pb-category')]) return;
      var nuovo = document.createElement('script');
      if (el.src) nuovo.src = el.src; else nuovo.textContent = el.textContent;
      el.parentNode.replaceChild(nuovo, el);
    });
    document.querySelectorAll('iframe[data-pb-src][data-pb-category]').forEach(function (el) {
      if (scelta[el.getAttribute('data-pb-category')]) { el.src = el.getAttribute('data-pb-src'); el.removeAttribute('data-pb-src'); }
    });
  }

  // ---------- il riquadro ----------

  var CSS = '#pb-riquadro{position:fixed;left:12px;right:12px;bottom:12px;z-index:2147483000;max-width:560px;margin:0 auto;padding:20px 20px 18px;border-radius:22px;' +
    'background:' + C.sfondo + ';color:' + C.testo + ';font:400 15px/1.5 ' + C.carattere + ';box-shadow:inset 0 0 0 1px ' + C.filo + ',0 14px 40px rgba(0,0,0,.45);box-sizing:border-box}' +
    '#pb-riquadro *{box-sizing:border-box;font-family:' + C.carattere + '!important;text-transform:none!important;letter-spacing:normal!important}#pb-riquadro .pb-titolo{margin:0 40px 6px 0;font:700 18px/1.25 ' + C.carattere + ';color:' + C.testo + '}' +
    '#pb-riquadro .pb-testo{margin:0 0 14px;color:' + C.tenue + '}#pb-riquadro a{color:' + C.testo + ';text-underline-offset:3px}' +
    '#pb-riquadro .pb-tasti{display:flex;flex-wrap:wrap;gap:8px}' +
    // «accetta» e «rifiuta» hanno la stessa identica pillola
    '#pb-riquadro .pb-t{flex:1 1 120px;min-height:44px;padding:0 18px;border:0;border-radius:99px;background:' + C.tasto + ';color:' + C.testoTasto + ';font:700 15px/1 ' + C.carattere + ';cursor:pointer}' +
    '#pb-riquadro .pb-t.pb-leggero{background:transparent;color:' + C.testo + ';box-shadow:inset 0 0 0 1px ' + C.filo + '}' +
    '#pb-riquadro .pb-x{position:absolute;top:10px;right:10px;width:40px;height:40px;border:0;border-radius:50%;background:transparent;color:' + C.testo + ';font:400 24px/1 ' + C.carattere + ';cursor:pointer}' +
    '#pb-riquadro .pb-voci{margin:0 0 14px;padding:0}#pb-riquadro .pb-voce{display:flex;gap:12px;align-items:flex-start;padding:10px 0;border-top:1px solid ' + C.filo + '}' +
    '#pb-riquadro .pb-voci b{display:block;font-weight:700;color:' + C.testo + '}#pb-riquadro .pb-voci span{display:block;color:' + C.tenue + ';font-size:13.5px}' +
    // la casella si vede sempre, anche se il tema del sito nasconde le caselle per ridisegnarle
    '#pb-riquadro .pb-voci input{flex:none;display:inline-block!important;position:static!important;opacity:1!important;visibility:visible!important;-webkit-appearance:auto!important;appearance:auto!important;width:22px!important;height:22px!important;margin:2px 0 0!important;accent-color:' + C.tasto + '}' +
    '#pb-riquadro .pb-voci label{display:block;cursor:pointer}#pb-riquadro .pb-voci label::before,#pb-riquadro .pb-voci label::after{content:none!important}' +
    '#pb-riquadro [hidden]{display:none}';

  var cp = null, pronto = false;

  function chiudi() { var r = document.getElementById('pb-riquadro'); if (r) r.remove(); }

  function mostra() {
    chiudi();
    if (!document.getElementById('pb-stile')) { var st = document.createElement('style'); st.id = 'pb-stile'; st.textContent = CSS; document.head.appendChild(st); }
    var ora = leggi(cp) || {};
    var r = document.createElement('div');
    r.id = 'pb-riquadro'; r.setAttribute('role', 'dialog'); r.setAttribute('aria-labelledby', 'pb-titolo');
    r.innerHTML = '<button type="button" class="pb-x" id="pb-chiudi" aria-label="' + T.chiudi + '">×</button>' +
      '<div class="pb-titolo" id="pb-titolo" role="heading" aria-level="2">' + T.titolo + '</div><div class="pb-testo">' + T.testo + ' <a href="' + INFORMATIVA + '">' + T.informativa + '</a>.</div>' +
      '<div class="pb-voci" id="pb-voci" hidden>' + VOCI.map(function (v) {
        return '<div class="pb-voce"><input type="checkbox" id="pb-' + v + '"' + (ora[v] ? ' checked' : '') + '><label for="pb-' + v + '"><b>' + T[v] + '</b><span>' + T[v + 'Cosa'] + '</span></label></div>';
      }).join('') + '</div>' +
      '<div class="pb-tasti"><button type="button" class="pb-t" id="pb-rifiuta">' + T.rifiuta + '</button><button type="button" class="pb-t" id="pb-accetta">' + T.accetta + '</button>' +
      '<button type="button" class="pb-t pb-leggero" id="pb-scegli">' + T.scegli + '</button></div>';
    document.body.appendChild(r);

    // il riquadro si chiude subito al tocco; la scelta viene scritta intanto (Shopify può metterci un momento a rispondere)
    var tutto = function (si) { return function () { chiudi(); scrivi(cp, { statistiche: si, pubblicita: si, preferenze: si }); }; };
    document.getElementById('pb-accetta').addEventListener('click', tutto(true));
    document.getElementById('pb-rifiuta').addEventListener('click', tutto(false));
    document.getElementById('pb-chiudi').addEventListener('click', tutto(false));
    document.getElementById('pb-scegli').addEventListener('click', function () {
      var voci = document.getElementById('pb-voci');
      if (voci.hidden) { voci.hidden = false; this.textContent = T.salva; return; }
      var scelta = {}; VOCI.forEach(function (v) { scelta[v] = document.getElementById('pb-' + v).checked; });
      chiudi(); scrivi(cp, scelta);
    });
  }

  function avvia() {
    shopify(function (api) {
      cp = api; pronto = true;
      var scelta = leggi(cp);
      if (scelta) { if (!cp) accendi(scelta); return; }
      // Su Shopify il riquadro serve solo dove il negozio chiede il consenso (lo decide Shopify dalla regione del visitatore).
      if (cp && typeof cp.shouldShowBanner === 'function' && !cp.shouldShowBanner()) return;
      mostra();
    });
  }

  window.PrivacyBull = { apri: function () { if (pronto) mostra(); }, scelta: function () { return leggi(cp); } };

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-privacybull-apri], a[href="#scelte-cookie"]');
    if (a) { e.preventDefault(); window.PrivacyBull.apri(); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
})();
